import CustomerEmailEditor from './customer_email_editor';
import CustomerEmailDisplay from './customer_email_display';
import ClickToEditField from 'components/common/click_to_edit_field';

export default ClickToEditField(CustomerEmailDisplay, CustomerEmailEditor);



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/profile/customer_email_field.jsx